import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosResponse, HttpStatusCode } from "axios";
import { ApiUrlUtil } from "app/utils/apiUrlUtil";
import { HeadersUtil } from "app/utils/headersUtil";
import { ResponseApi, ResponseResultCode } from "app/model/response-api";
import {MgResourceModel} from "../model/common/mgResourceModel";

interface StateModel {
  mgResources: MgResourceModel[],
  hasPv: boolean,
  hasEss: boolean,
  hasFacility: boolean,
  hasFlexResource: boolean
}

const initialState: StateModel = {
  mgResources: [],
  hasPv: false,
  hasEss: false,
  hasFacility: false,
  hasFlexResource: false
};

export const getMgResources = createAsyncThunk("/user/resources", async () => {
  const url = process.env.REACT_APP_URL_CO + '/user/resources';
  const axiosResponse: AxiosResponse = await axios.get(ApiUrlUtil.buildQueryString(url), {
    headers: HeadersUtil.getHeadersAuth(),
  });

  if (axiosResponse && HttpStatusCode.Ok === axiosResponse.status) {
    const apiResponse: ResponseApi<MgResourceModel[]> = axiosResponse.data;
    if (apiResponse && ResponseResultCode.Y === apiResponse.resultCode) {
      return apiResponse.data;
    }
  }
  return [];
});

const mgResourceSlice = createSlice({
  name: 'mgResource',
  initialState,
  reducers: {
    setMgResources: (state, action) => {
      state.mgResources = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(getMgResources.pending, () => {})
    .addCase(getMgResources.fulfilled, (state, action) => {
      const data: MgResourceModel[] = action.payload;
      if (data) {
        state.mgResources = data;
        state.hasPv = data.filter((r) => r.emksRsrcClCd === 1).length > 0;
        state.hasEss = data.filter((r) => r.emksRsrcClCd === 22).length > 0;
        state.hasFacility = data.filter((r) => r.emksRsrcClCd === 23).length > 0;
        state.hasFlexResource = data.filter((r) => r.flxRsrcYn === 'Y').length > 0;
      }
    })
    .addCase(getMgResources.rejected, (state) => {
      state.mgResources = [];
      state.hasPv = false;
      state.hasEss = false;
      state.hasFacility = false;
      state.hasFlexResource = false;
    });
  },
});

export default mgResourceSlice.reducer;